import styled from 'styled-components'
import vars from 'scss/variables.js'

const { redwebmotors, white } = vars

export const Container = styled.div`
  width: 100%;
  padding: 60px 20px;
`

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 500;
  color: ${redwebmotors};
  a {
    text-decoration: none;
    color: ${redwebmotors};
  }
`

export const LinkGroup = styled.ul`
  column-count: 4;
  min-height: 320px;
`

export const LinkList = styled.li`
  display: block;
`
export const LinkItem = styled.a`
  font-size: 12px;
  color: #686976;
  line-height: 2.2em;
  text-decoration: underline;
`

export const Pagination = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
`

export const LinkPage = styled.a`
  padding: 5px;
  margin: 0 15px;
  font-size: 15px;
  font-weight: 400;
  border-radius: 4px;

  &:first-of-type {
    margin-left: 0px;
  }

  &.selected {
    background-color: #2e2e37;
    color: ${white};
  }
`
